/*
 * HSPG homepage 2026 — guide rail (auto-playing slideshow, 3 / 2 / 1 per view).
 * Behaviour ported from the confirmed design reference, restructured as
 * init(sectionEl) so the theme editor can re-init a single section instance.
 */
(function () {
  'use strict';

  var GAP = 22;
  var DELAY = 4000;
  var instances = [];

  function findInstance(root) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root === root) return instances[i];
    }
    return null;
  }

  function destroy(root) {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (instances[i].root === root) {
        instances[i].teardown();
        instances.splice(i, 1);
      }
    }
  }

  /* The theme editor can swap a section for a brand-new element; anything left
     pointing at detached markup is torn down so no orphan timer keeps running. */
  function prune() {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!instances[i].root.isConnected) {
        instances[i].teardown();
        instances.splice(i, 1);
      }
    }
  }

  function init(root) {
    if (!root) return null;
    destroy(root);

    var rail = root.querySelector('[data-hspg2026-rail]');
    if (!rail) return null;

    var band = rail.closest('[data-hspg2026-band]') || root;
    var prev = root.querySelector('[data-hspg2026-prev]');
    var next = root.querySelector('[data-hspg2026-next]');
    var dotsEl = root.querySelector('[data-hspg2026-dots]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-hspg2026-chip]'));
    var cards = Array.prototype.slice.call(rail.children);
    if (!cards.length) return null;

    var controller = new AbortController();
    var opts = { signal: controller.signal };
    var passiveOpts = { signal: controller.signal, passive: true };
    var cur = 0;
    var timer = null;
    var settleTimer = null;
    /* Four independent reasons autoplay may be held: the pointer is on the
       band, focus is inside it, the tab is in the background, or the theme
       editor has a rail block selected. They are tracked separately so
       releasing one never resumes while another still holds. */
    var pointerHold = false;
    var focusHold = false;
    var hiddenHold = document.hidden;
    var editorHold = false;

    function isHeld() {
      return pointerHold || focusHold || hiddenHold || editorHold;
    }

    function stepW() {
      return cards[0].getBoundingClientRect().width + GAP;
    }

    function positions() {
      var width = stepW();
      if (!width) return 1;
      var perView = Math.max(1, Math.round((rail.clientWidth + GAP) / width));
      return Math.max(1, cards.length - perView + 1);
    }

    function paint() {
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (dot, i) {
          dot.classList.toggle('is-on', i === cur);
        });
      }
      paintChips();
    }

    /* The chips are a filter row AND a position indicator: clicking one jumps the rail,
       so the lit chip has to keep matching whatever the rail is showing. Only the click
       handler used to write `is-active`, so autoplay, arrows, dots and swipes all left
       the wrong chip lit — invisible at desktop 3-up, but at 1-up a single card is on
       screen beside a chip naming a different guide. Key off the leading card. */
    function paintChips() {
      if (!chips.length || !cards[cur]) return;
      var id = cards[cur].getAttribute('data-card-id');
      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', chip.getAttribute('data-target') === id);
      });
    }

    function go(i) {
      var n = positions();
      clearTimeout(settleTimer);
      cur = ((i % n) + n) % n;
      rail.scrollTo({ left: cur * stepW(), behavior: 'smooth' });
      paint();
    }

    function buildDots() {
      if (!dotsEl) return;
      var total = positions();
      /* Resize fires continuously (mobile URL bar, orientation change). Only
         rebuild when the dot count actually changed — otherwise a focused dot
         would be destroyed under the visitor, which also fires `focusout` and
         would resume autoplay mid-interaction. */
      if (dotsEl.children.length === total) {
        paint();
        return;
      }
      dotsEl.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hspg2026-dot-i' + (i === cur ? ' is-on' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener(
          'click',
          (function (index) {
            return function () {
              go(index);
              reset();
            };
          })(i),
          opts
        );
        dotsEl.appendChild(dot);
      }
    }

    function start() {
      if (!timer && !isHeld()) {
        timer = setInterval(function () {
          go(cur + 1);
        }, DELAY);
      }
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    /* Restart the clock after a manual jump — but `start()` respects the holds,
       so clicking an arrow, dot or chip never drags the rail out from under a
       visitor whose pointer is still on the band. */
    function reset() {
      stop();
      start();
    }

    if (prev) {
      prev.addEventListener(
        'click',
        function () {
          go(cur - 1);
          reset();
        },
        opts
      );
    }

    if (next) {
      next.addEventListener(
        'click',
        function () {
          go(cur + 1);
          reset();
        },
        opts
      );
    }

    /* Sync the dots to a *settled* rail position only. A smooth `scrollTo`
       fires a stream of scroll events on the way to the target: reading them
       live drags `cur` backwards mid-flight, which flickers the dots and — when
       the last event of the animation is missed — leaves `cur` one position
       behind, so the next autoplay tick re-issues a scroll that is already
       done and the rail stalls for a full cycle. */
    function syncFromScroll() {
      var width = stepW();
      if (!width) return;
      var i = Math.min(positions() - 1, Math.max(0, Math.round(rail.scrollLeft / width)));
      if (i !== cur) {
        cur = i;
        paint();
      }
    }

    rail.addEventListener(
      'scroll',
      function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(syncFromScroll, 120);
      },
      passiveOpts
    );

    ['pointerenter', 'touchstart'].forEach(function (ev) {
      band.addEventListener(
        ev,
        function () {
          pointerHold = true;
          stop();
        },
        passiveOpts
      );
    });

    band.addEventListener(
      'pointerleave',
      function () {
        pointerHold = false;
        start();
      },
      passiveOpts
    );

    /* Only *keyboard* focus holds autoplay. Clicking an arrow, dot or chip also
       focuses it, and a mouse visitor who then moves away would otherwise be
       left with a rail frozen forever by a button nobody is looking at. */
    function keyboardFocus(el) {
      if (!el || !el.matches) return false;
      try {
        return el.matches(':focus-visible');
      } catch (e) {
        return true;
      }
    }

    band.addEventListener(
      'focusin',
      function (event) {
        if (!keyboardFocus(event.target)) return;
        focusHold = true;
        stop();
      },
      passiveOpts
    );

    band.addEventListener(
      'focusout',
      function (event) {
        if (event.relatedTarget && band.contains(event.relatedTarget)) return;
        focusHold = false;
        start();
      },
      opts
    );

    /* A background tab still runs the interval, but a smooth `scrollTo` cannot
       animate there: `cur` and the dots would march on while the rail sat
       still, so returning to the tab showed dots pointing at one slide and the
       rail at another, then a multi-card jump on the next tick. */
    document.addEventListener(
      'visibilitychange',
      function () {
        hiddenHold = document.hidden;
        if (hiddenHold) {
          stop();
        } else {
          start();
        }
      },
      opts
    );

    window.addEventListener(
      'resize',
      function () {
        cur = Math.min(cur, positions() - 1);
        buildDots();
      },
      opts
    );

    chips.forEach(function (chip) {
      chip.addEventListener(
        'click',
        function () {
          var idx = indexOfCard(chip.getAttribute('data-target'));
          if (idx > -1) {
            /* `go` repaints the chips from the card it lands on, which is the honest
               state when the index is clamped at the end of the rail. */
            go(Math.min(idx, positions() - 1));
            reset();
          }
        },
        opts
      );
    });

    function indexOfCard(cardId) {
      if (!cardId) return -1;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-card-id') === cardId) return i;
      }
      return -1;
    }

    buildDots();
    /* Paint once before autoplay so the chip row agrees with the card the rail opens on.
       The section markup lights the "all guides" chip server-side, which is only correct
       when the offer card happens to lead. */
    paint();
    start();

    var instance = {
      root: root,
      teardown: function () {
        stop();
        clearTimeout(settleTimer);
        controller.abort();
      },
      /* Theme editor: selecting a guide/offer block parks the rail on that card
         and holds autoplay. Selecting any other block (hero, who, why) is not a
         rail block, so the rail is left alone rather than silently frozen. */
      selectCard: function (cardId) {
        var idx = indexOfCard(cardId);
        if (idx < 0) return;
        editorHold = true;
        stop();
        chips.forEach(function (chip) {
          chip.classList.toggle('is-active', chip.getAttribute('data-target') === cardId);
        });
        go(Math.min(idx, positions() - 1));
      },
      release: function () {
        editorHold = false;
        start();
      }
    };

    instances.push(instance);
    return instance;
  }

  /* ===== reviews: "Show more" toggle =====
     The grid is server-rendered collapsed (cards past `reviews_initial` carry
     `is-extra`); this only flips the class and keeps the button honest. */
  function initReviews(root) {
    var grids = root.querySelectorAll('[data-hspg2026-reviews]');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.hspg2026Reviews) return;
      var band = grid.closest('.hspg2026-reviews') || root;
      var btn = band.querySelector('[data-hspg2026-reviews-toggle]');
      if (!btn) return;
      var label = btn.querySelector('span');
      var more = btn.getAttribute('data-label-more') || '';
      var less = btn.getAttribute('data-label-less') || more;

      function paint() {
        var collapsed = grid.classList.contains('is-collapsed');
        if (label) label.textContent = collapsed ? more : less;
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }

      btn.addEventListener('click', function () {
        var collapsed = grid.classList.toggle('is-collapsed');
        paint();
        /* Collapsing from the foot of the open grid can leave the viewport
           parked past the band; bring its top edge back into view. */
        if (collapsed && grid.getBoundingClientRect().top < 0) {
          grid.scrollIntoView({ block: 'start' });
        }
      });

      grid.hspg2026Reviews = { paint: paint };
      paint();
    });
  }

  /* Theme editor: selecting a review hidden behind "Show more" would scroll the
     preview to a display:none card, so open the grid first. */
  function expandReviews(card) {
    var grid = card.closest('[data-hspg2026-reviews]');
    if (!grid || !grid.classList.contains('is-collapsed')) return;
    grid.classList.remove('is-collapsed');
    if (grid.hspg2026Reviews) grid.hspg2026Reviews.paint();
  }

  function boot(scope) {
    prune();
    var context = scope || document;
    var roots = context.querySelectorAll('[data-hspg2026-home]');
    Array.prototype.forEach.call(roots, function (root) {
      init(root);
      initReviews(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-hspg2026-home]');
    Array.prototype.forEach.call(roots, function (root) {
      destroy(root);
    });
    prune();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-hspg2026-home]');
    if (!root) return;
    if (event.target.classList && event.target.classList.contains('hspg2026-rv-card')) {
      expandReviews(event.target);
      return;
    }
    var instance = findInstance(root) || init(root);
    var cardId = (event.detail && event.detail.blockId) || event.target.getAttribute('data-card-id');
    if (instance) instance.selectCard(cardId);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-hspg2026-home]');
    if (!root) return;
    var instance = findInstance(root);
    if (instance) instance.release();
  });
})();
